export enum JourneyTimeType {
    DepartingAt = "DepartingAt",
    ArrivingBefore = "ArrivingBefore"
}
